<template>
  <a-card :bordered="false" class="card-area">
    <div>
      <!-- 搜索区域 -->
      <a-form layout="horizontal">
        <a-row>
          <div style="display: flex">
            <AreaCascader style="width:500px;margin-top: -3px" @loaded="onLoaded"  ref="outSelect" />
           <div style="margin: 0px 20px 0px 20px">
             <a-input placeholder="手机号精确搜索" v-model="queryParams.mobile"/>
           </div>

            <span>
                <a-button type="primary" @click="search">查询</a-button>
                <a-button style="margin-left: 8px" @click="reset">重置</a-button>
              </span>

          </div>

        </a-row>
      </a-form>
    </div>
    <div>
      <div class="operator">

        <a-button type="primary" ghost @click="downloadTemplate">导入模板下载</a-button>

        <a-upload
          class="upload-area"
          :fileList="fileList"
          :remove="handleRemove"
          :disabled="fileList.length === 1"
          :beforeUpload="beforeUpload">
          <a-button ghost type="primary">
            <a-icon type="upload"/>
            批量导入
          </a-button>
        </a-upload>
      </div>
      <!-- 表格区域 -->
      <a-table ref="TableInfo"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="pagination"
               :loading="loading"
               :scroll="{ x: 900 }"
               @change="handleTableChange">
        <template slot="email" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <div>{{text}}</div>
            </template>
            <p style="width: 150px;margin-bottom: 0">{{text}}</p>
          </a-popover>
        </template>
        <template  slot="operation" slot-scope="text, record">
          <a-button type="danger" @click="del(record)">删除</a-button>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-select v-model="record.statusStr"  style="width: 100px" @change="handleStatusChange(record)">
            <a-select-option value="0">停用</a-select-option>
            <a-select-option value="1">正常</a-select-option>
          </a-select>
        </template>
      </a-table>
    </div>

    <a-modal
      :title="modalTitle"
      placement="right"
      width="600px"
      :closable="false"
      :visible="modalVisible"
      @close="onModalClose"
      style="height: calc(100% - 55px);overflow: auto;padding-bottom: 53px;">

      <a-form :form="form" @submit="handleSubmit"  >

        <a-row :gutter="24">
          <a-col :span="12" >
            <a-form-item label='负责人' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input v-decorator="['name',{rules: [{ required: true, message: '请输入姓名' }]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label='账号' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input  :disabled="modalTitle=='编辑'"  v-decorator="['username',{rules: [{ required: true, message: '请输入账号' }]}]"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12" >
            <a-form-item label='手机号' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input  v-decorator="['mobile',{rules: [{ required: true, message: '请输入手机号' }]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="modalTitle!='编辑'">
            <a-form-item label='密码' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-input  v-decorator="['password',{rules: [{ required: true, message: '请输入密码' }]}]"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12" >
            <a-form-item label='主账号' v-bind="{labelCol: { span:8 },wrapperCol: { span: 16 }}" >
              <a-radio-group  v-decorator="['main',{rules: [{ required: true, message: '请选择是否主账号' }]}]" >
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item label='区域权限' v-bind="formItemLayout">
          <AreaCascader @change="onCityChange" ref="select" />
        </a-form-item>

      </a-form>
      <template slot="footer">
        <a-button key="back" @click="onModalClose">取消</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
          确认
        </a-button>
      </template>
    </a-modal>


    <!-- 修改角色 -->
    <role-edit
      ref="roleEdit"
      :roleInfoData="roleInfo.data"
      @close="handleRoleEditClose"
      @success="handleRoleEditSuccess"
      :roleEditVisiable="roleEdit.visiable">
    </role-edit>



    <import-result
      @close="handleResultClose"
      :importData="importData"
      :errors="errors"
      :times="times"
      :successColumns="[{
          title: '用户姓名',
          dataIndex: 'name'
        },{
          title: '手机号',
          dataIndex: 'phone'
        }]"
      :importResultVisible="importResultVisible">
    </import-result>



  </a-card>
</template>

<script>
  import DeptInputTree from '../system/dept/DeptInputTree'
  import RangeDate from '@/components/datetime/RangeDate'
  import area from '../../utils/area'
  import AreaCascader from '@/components/select/AreaCascader'
  import RoleAdd from './PerAdd'
  import RoleEdit from './PerEdit'
  import ImportResult from '@/views/common/ImportResult'
  const formItemLayout = {
    labelCol: {span: 4},
    wrapperCol: {span: 20}
  }
  export default {
    name: 'Jiedaoer',
    components: {DeptInputTree, RangeDate,AreaCascader, RoleAdd, RoleEdit,  ImportResult,},
    data () {
      return {
        fileList: [],
        form: this.$form.createForm(this),
        modalTitle: '',
        modalVisible: false,
        modalData: {},
        roleInfo: {
          visiable: false,
          data: {}
        },
        roleAdd: {
          visiable: false
        },
        roleEdit: {
          visiable: false
        },
        currentStatus:"",
        options: area,
        formItemLayout,
        queryParams: {status: ''},
        filteredInfo: null,
        sortedInfo: null,
        paginationInfo: null,
        autoData:[],
        streetMap:{},
        times: 0,
        errors: [],
        importData: [],
        importResultVisible:false,
        validateStatus: 'success',
        dataSource: [],
        selectedRowKeys: [],
        loading: false,
        pagination: {
          pageSizeOptions: ['10', '20', '30', '40', '100'],
          defaultCurrent: 1,
          defaultPageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
        }
      }
    },
    computed: {
      columns () {
        let {sortedInfo, filteredInfo} = this
        sortedInfo = sortedInfo || {}
        filteredInfo = filteredInfo || {}
        return [{
          title: '负责人名字',
          dataIndex: 'name'
        }, {
          title: '手机号',
          dataIndex: 'mobile'
        }, {
          title: '网格',
          dataIndex: 'wgName'
        }, {
          title: '管辖区域',
          dataIndex: 'areaStr'
        },{
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'}
        }]
      }
    },
    mounted () {

    },
    methods: {
      downloadTemplate() {
        window.open('/static/走亲干部导入模板.xlsx')
      },
      handleResultClose() {
        this.importResultVisible = false
      },
      handleRemove(file) {
        if (this.uploading) {
          this.$message.warning('文件导入中，请勿删除')
          return
        }
        const index = this.fileList.indexOf(file)
        const newFileList = this.fileList.slice()
        newFileList.splice(index, 1)
        this.fileList = newFileList
      },
      beforeUpload(file) {
        this.fileList = [...this.fileList, file]
        this.handleUpload()
        return false
      },
      handleUpload() {
        const {fileList} = this
        const formData = new FormData()
        formData.append('file', fileList[0])
        this.uploading = true
        this.$upload('user/user/import', formData).then((r) => {
          let data = r.data.data
          if (data.data.length) {
            this.search()
          }
          this.importData = data.data
          this.errors = data.error
          this.times = data.time / 1000
          this.uploading = false
          this.fileList = []
          this.importResultVisible = true
        }).catch((r) => {
          console.error(r)
          this.uploading = false
          this.fileList = []
        })
      },
      add () {
        this.modalData = {}
        this.modalTitle = '新增'
        this.modalVisible = true
        this.$nextTick(() => {
          this.form.setFieldsValue({no: '', no1: '', no2: ''})
        })
      },
      handleRoleAddClose () {
        this.roleAdd.visiable = false
      },
      handleRoleAddSuccess () {
        this.roleAdd.visiable = false
        this.$message.success('新增角色成功')
        this.search()
      },

      editPer (record) {
        this.$refs.roleEdit.setFormValues(record)
        this.roleInfo.data = record
        this.roleEdit.visiable = true
      },
      handleRoleEditSuccess () {
        this.roleEdit.visiable = false
        this.$message.success('修改角色成功')
        this.search()
      },
      handleRoleEditClose () {
        this.roleEdit.visiable = false
      },

      onLoaded(){
        this.fetch()
      },
      handleSearch (value) {
        if (value.length == 0) {
          return
        }

        this.$get('street/query', {name: value}).then((r) => {
          let data = r.data
          this.autoData = data.rows.map(o => o.name)
          data.rows.map(o=>{
            this.streetMap[o.name] = o.id
          })
        }).catch(() => {
        })
      },
      onSelect (value) {
       this.form.setFieldsValue({streetId:this.streetMap[value]})
      },
      handleStatus(record){
        console.log(`record `,record);
      },
      handleStatusChange (value) {
        console.log(`selected `,this.currentStatus,value);
      },

      onCityChange (value, selectedOptions) {

      },
      handleSubmit () {
        this.form.validateFields((err, values) => {
          if (!err) {
            let datas = this.form.getFieldsValue()
            datas.streetId = this.$refs.select.getValue()
            this.loading = true
            this.$post('user/streetManager', datas).then((r) => {
              this.loading = false
              this.modalVisible = false
              this.reset()
            }).catch(() => {
              this.loading = false
            })
          }
        })
      },
      onModalClose () {
        this.modalVisible = false
      },

      edit (record) {
        this.modalTitle = '编辑'
        this.modalVisible = true
        this.modalData = record
        record.areas = [record.province+"",record.city+"",record.area+""]
         this.$nextTick(() => {
          this.form.setFieldsValue(record)
        })

      },
      onSelectChange (selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
        if (!this.advanced) {
          this.queryParams.createTimeFrom = ''
          this.queryParams.createTimeTo = ''
        }
      },
      del (record) {
        let that = this
        this.$confirm({
          title: '确定删除吗?',
          content: '当您点击确定按钮后，这些记录将会被彻底删除',
          centered: true,
          onOk () {
            that.$delete('user/' + record.userId).then(() => {
              that.$message.success('删除成功')
              that.selectedRowKeys = []
              that.search()
            })
          },
          onCancel () {
            that.selectedRowKeys = []
          }
        })
      },
      handleUserAddClose () {
        this.userAdd.visiable = false
      },
      handleUserAddSuccess () {
        this.userAdd.visiable = false
        this.$message.success('新增用户成功，初始密码为000000')
        this.search()
      },
      handleUserEditClose () {
        this.userEdit.visiable = false
      },
      handleUserEditSuccess () {
        this.userEdit.visiable = false
        this.$message.success('修改用户成功')
        this.search()
      },
      handleUserInfoClose () {
        this.userInfo.visiable = false
      },
      handleDeptChange (value) {
        this.queryParams.deptId = value || ''
      },
      handleDateChange (value) {
        if (value) {
          this.queryParams.createTimeFrom = value[0]
          this.queryParams.createTimeTo = value[1]
        }
      },
      resetPassword (record) {
        let that = this
        this.$confirm({
          title: '确定重置选中用户密码?',
          content: '当您点击确定按钮后，这些用户的密码将会重置为000000',
          centered: true,
          onOk () {
            that.$put('user/password/reset', {
              usernames: record.username
            }).then(() => {
              that.$message.success('重置用户密码成功')
              that.selectedRowKeys = []
            })
          },
          onCancel () {
            that.selectedRowKeys = []
          }
        })
      },
      exportExcel () {
        let {sortedInfo, filteredInfo} = this
        let sortField, sortOrder
        // 获取当前列的排序和列的过滤规则
        if (sortedInfo) {
          sortField = sortedInfo.field
          sortOrder = sortedInfo.order
        }
        this.$export('user/excel', {
          sortField: sortField,
          sortOrder: sortOrder,
          ...this.queryParams,
          ...filteredInfo
        })
      },
      search () {
        let {sortedInfo, filteredInfo} = this
        let sortField, sortOrder
        // 获取当前列的排序和列的过滤规则
        if (sortedInfo) {
          sortField = sortedInfo.field
          sortOrder = sortedInfo.order
        }
        this.fetch({
          sortField: sortField,
          sortOrder: sortOrder,
          ...this.queryParams,
          ...filteredInfo
        })
      },
      reset () {
        // 取消选中
        this.selectedRowKeys = []
        // 重置分页
        this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
        if (this.paginationInfo) {
          this.paginationInfo.current = this.pagination.defaultCurrent
          this.paginationInfo.pageSize = this.pagination.defaultPageSize
        }
        // 重置列过滤器规则
        this.filteredInfo = null
        // 重置列排序规则
        this.sortedInfo = null
        // 重置查询参数
        this.queryParams = {}

        this.fetch()
      },
      handleTableChange (pagination, filters, sorter) {
        // 将这三个参数赋值给Vue data，用于后续使用
        this.paginationInfo = pagination
        this.filteredInfo = filters
        this.sortedInfo = sorter

        this.fetch({
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...this.queryParams,
          ...filters
        })
      },
      fetch (params = {}) {
        // 显示loading
        this.loading = true
        if (this.paginationInfo) {
          // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
          this.$refs.TableInfo.pagination.current = this.paginationInfo.current
          this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
          params.pageSize = this.paginationInfo.pageSize
          params.pageNum = this.paginationInfo.current
        } else {
          // 如果分页信息为空，则设置为默认值
          params.pageSize = this.pagination.defaultPageSize
          params.pageNum = this.pagination.defaultCurrent
        }
        params.streetId = this.$refs.outSelect.getValue()
        this.$get('user/zqgb_manager', {
          ...params
        }).then((r) => {
          let data = r.data
          const pagination = {...this.pagination}
          pagination.total = data.total
          this.dataSource = data.rows
          this.pagination = pagination
          // 数据加载完毕，关闭loading
          this.loading = false
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import "../../../static/less/Common";
</style>



// WEBPACK FOOTER //
// src/views/sys/zqgb.vue